module.exports = __webpack_public_path__ + "images/closea19d600f8464e9cc815281dfc81f8dbf.svg";